import { create } from 'zustand';

export const useWizardStore = create((set) => ({
    choiceModalOpen: false,
    distributionWizardOpen: false,
    selectedSiteId: null,

    setChoiceModalOpen: (open) => set({ choiceModalOpen: open }),
    setDistributionWizardOpen: (open, siteId = null) => set({
        distributionWizardOpen: open,
        selectedSiteId: siteId || null
    }),
}));
